import { Injectable, inject } from "@angular/core";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { ICartItem } from "../model/cartItem.model";
import { environment } from "../../environments/environment";
import { ICart } from "../model/cart.model";

@Injectable()
export class ShoppingCartService{
    authService = inject(AuthenticationService);

    constructor(private http: HttpClient) {
    }

    addToCart(item: ICartItem): Observable<ICart> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        return this.http.post<ICart>( environment.API_URL + '/api/ShoppingCart/AddToCart', item, options);
    }

    removeFromCart(id: string): Observable<ICart> {
        const token = this.authService.getUserToken();

        let item = {
            id: id
        }

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ICart>( environment.API_URL + `/api/ShoppingCart/RemoveFromCart`, item, options);
        } else {
            return of();
        }
    }

    updateCartQuantity(item: ICartItem): Observable<ICart> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ICart>( environment.API_URL + '/api/ShoppingCart/UpdateCartQuantity', item, options);
        } else {
            return of();
        }
    }

    checkCart(cartId: string): Observable<ICart> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<ICart>( environment.API_URL + `/api/shoppingCart/check/${cartId}`, options)
        } else {
            return of();
        }
    }

    getCartData(id: string): Observable<ICart> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };
        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<ICart>( environment.API_URL + `/api/ShoppingCart/getCart/${id}`, options);
        } else {
            return of();
        }
    }

    getMyCart(): Observable<ICart> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<ICart>( environment.API_URL + `/api/ShoppingCart/getMyCart`, options);
        } else {
            return of();
        }
    }

    emptyCart(): Observable<boolean> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<boolean>( environment.API_URL + `/api/ShoppingCart/emptyCart`, options);
        } else {
            return of(false);
        }
    }
}
